import type { PropsWithChildren } from "react";

import { cn } from "../../utils";
import { useAlertRootContext } from "./context";
import { alertBadgeStyle, alertBadgeTitleStyle, alertLayoutStyle } from "./styles";

export type AlertBadgeLayoutProps = PropsWithChildren<{ badge: string; title: string; className?: string }>;

const BadgeLayout = ({ children, badge, title, className }: AlertBadgeLayoutProps) => {
  const { type, orientation } = useAlertRootContext();

  return (
    <div className={cn(alertLayoutStyle({ orientation }), "gap-3", className)}>
      <div className={alertBadgeTitleStyle({ type })}>
        <span className={alertBadgeStyle({ type })}>{badge}</span>
        <h3>{title}</h3>
      </div>
      {children}
    </div>
  );
};

export default BadgeLayout;
